module.exports = __webpack_public_path__ + "img/senior-logo-10.729d3fe7.png";